module.exports = __webpack_public_path__ + "static/media/companyinfo.923c12d2.png";